var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.IsEmailEnabled()
    ? _c(
        "div",
        { attrs: { id: "mailbox" } },
        [
          _c("AppBreadCrumb", {
            attrs: {
              paths: [{ title: _vm.$t("message.mail") }].concat(_vm.paths),
              "show-trial-remain-day": true,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "route-page-content breadcrumb-content" },
            [
              _c("SidebarChild", {
                attrs: {
                  selectedItem: _vm.selectedTab,
                  items: _vm.menuItems,
                  focusActive: true,
                },
                on: { selected: _vm.handleSidebarSelection },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-content-wrapper" },
                [
                  _vm.isSelected("inbox")
                    ? _c(
                        "div",
                        { attrs: { id: "mailbox-in" } },
                        [
                          _c("MailboxMenu", {
                            staticStyle: { "min-width": "15%" },
                            on: {
                              mailDetail: function (e) {
                                return (_vm.mailDetails = e)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-spin",
                            { attrs: { spinning: _vm.loading } },
                            [
                              _vm.selectedNewTemplate
                                ? _c("exampleView", {
                                    attrs: { userId: _vm.user._id },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.selectedNewTemplate
                                ? _c("MailList", {
                                    staticStyle: {
                                      "min-width": "27%",
                                      "max-width": "27%",
                                    },
                                    attrs: { isRefresh: _vm.refresh },
                                    on: {
                                      mailDetails: function (e) {
                                        return (_vm.mailDetails = e)
                                      },
                                      loading: function (e) {
                                        return (_vm.loading = e)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedNewMail && !_vm.selectedNewTemplate
                                ? _c("MailComposer", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      mailDetails: _vm.mailDetails,
                                      isNewMail: true,
                                      replyContent: "",
                                    },
                                    on: {
                                      newMailDetail: function (e) {
                                        return (_vm.newMailDetail = e)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.selectedNewMail &&
                              _vm.mailDetails.length === 0 &&
                              !_vm.selectedNewTemplate
                                ? _c("NoMessage", {
                                    staticClass: "empty-mail",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      desc: _vm.$t("mail.mailNotFound"),
                                      newMail: "true",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.selectedNewMail &&
                              _vm.mailDetails.length > 0 &&
                              !_vm.selectedNewTemplate
                                ? _c("ThreadViewer", {
                                    staticStyle: { width: "100%" },
                                    attrs: { mailDetails: _vm.mailDetails },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSelected("templates") ? _c("EmailTemplates") : _vm._e(),
                  _vm._v(" "),
                  _vm.isSelected("broadcast")
                    ? _c("EmailBroadcastList")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSelected("customer-groups")
                    ? _c("EmailCustomerGroups")
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }